import React from "react";
import { Form } from "antd";
import { BiMap } from "react-icons/bi";
import PlaceAutocomplete from "../../../component/place_autocomplete";

const UserAddress = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  const options = {
    types: [],
    fields: ["address_components", "formatted_address"],
    componentRestrictions: { country: ["nz"] },
  };
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------

  const handleSelect = (place) => {
    console.log({ place });
    const components = place?.address_components;
    const subs = components?.filter((item) => item.types?.includes("sublocality"));
    const postals = components?.filter((item) => item.types?.includes("postal_code"));
    const citys = components?.filter((item) => item.types?.includes("locality"));
    const states = components?.filter((item) =>
      item.types?.includes("administrative_area_level_1")
    );
    const subUrb = subs?.length > 0 ? subs[0]?.long_name : "";
    const postCode = postals?.length > 0 ? postals[0]?.long_name : "";
    const state = states?.length > 0 ? states[0]?.long_name : "";
    const city = citys?.length > 0 ? citys[0]?.long_name : "";
    props.onSelect({
      subUrb,
      postCode,
      state,
      city,
    });
  };

  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="address"
      label="Address"
      rules={[
        {
          required: true,
          message: "Please input address",
        },
      ]}
    >
      <PlaceAutocomplete
        name="address"
        icon={<BiMap />}
        options={options}
        disabled={disabled}
        onSelect={handleSelect}
      />
    </Form.Item>
  );
};

export default UserAddress;
